export const MAX_DEADLINE = 4320;
export const MIN_DEADLINE = 1;

const DEFAULT_DEADLINE = 30;

export default DEFAULT_DEADLINE;
